import React from 'react';
import PropTypes from 'prop-types';
import Popup from "../../../../../components/WMS/Mobile/Popup";
import {FormattedMessage} from "react-intl";
import {Grid} from "@mui/material";
import TextEmphasisBloc from "../../../../../components/WMS/TextEmphasisBloc";
import CustomButton from "../../../../../components/CustomButton";
import {blueColor} from "../../../../../assets/jss/main";

MultiHiveModal.propTypes = {

};

function MultiHiveModal({open, handleClose, containers, shipmentNumber, beginPacking, cancel}) {

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={<><FormattedMessage id={"wms.packing.modal.multiHiveModal.title"}/><span style={{color: blueColor}}>#{shipmentNumber}</span></>}
            subtitle={<FormattedMessage id={"wms.packing.modal.multiHiveModal.subtitle"}/>}
        >
            <Grid container direction={'column'} justifyContent={"space-between"}>
                {containers && containers.map(container => (
                    <TextEmphasisBloc leftPart={container.hiveName +" • "+ container.name} />
                ))}

                <Grid sx={{marginBottom: "8px"}}>
                    <CustomButton fullWidth onClick={() => beginPacking()}><FormattedMessage id={"wms.packing.modal.multiHiveModal.confirm"}/></CustomButton>
                </Grid>
                <CustomButton fullWidth color={"red"} variant={'nude'} onClick={() => cancel()}><FormattedMessage id={"wms.packing.modal.multiHiveModal.cancel"}/></CustomButton>
            </Grid>
        </Popup>
    );
}

export default MultiHiveModal;